import React from 'react'
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {Typography} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';

function EnhancedTableHead(props) {
  const { onSelectAllClick, numSelected, rowCount, headerList, isSubHeader } = props;

  return (
    <TableHead className={isSubHeader ? "back-gray" : "primary"}>
      <TableRow>
        {!isSubHeader && (
        <TableCell padding="checkbox">
        </TableCell>
        )}
        <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell>
        {headerList.map((headCell, index) => (
          <TableCell
            key={index}
            align='left'
          >
            <Typography
            >
              {headCell}
            </Typography>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
  headerList: PropTypes.array.isRequired,
  isSubHeader: PropTypes.bool.isRequired
};

export default EnhancedTableHead;